import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  query: "",
  queryError: "",
};

const searchQuerySlice = createSlice({
  name: "searchQuery",
  initialState,
  reducers: {
    setQuery: (state, action) => {
      state.query = action.payload;
    },
    setQueryError: (state, action) => {
      state.queryError = action.payload;
    },
  },
});

export const { setQuery, setQueryError } = searchQuerySlice.actions;
export default searchQuerySlice.reducer;
